import { render, staticRenderFns } from "./PlayerParams.vue?vue&type=template&id=3b3f8788&"
import script from "./PlayerParams.vue?vue&type=script&lang=js&"
export * from "./PlayerParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports